export default {
	unsplash: {
		attribution: 'Photo by {{author}}',
		discovery: {
			title: 'Search Unsplash to choose an image',
			description:
				'Run a search to browse results and select the image you want to use.',
		},
		idLookup: {
			label: 'Find by photo ID',
			placeholder: 'e.g., abc123XYZ',
			action: 'Find',
			help: 'Use this when you already know the exact Unsplash photo ID.',
			error: 'Could not find that photo ID.',
		},
		search: {
			placeholder: 'e.g., technology, nature, business...',
		},
		loading: 'Loading images...',
		error: 'Failed to load images. Please try again.',
		empty: 'No images found for this search.',
		photoAlt: 'Unsplash photo',
		courseCoverAlt: 'Supporting image for the route {{courseTitle}}',
	},
}
